// Tenant API Service - Backend Integration
import { apiGet, apiPost, apiPut, apiDelete } from '../services/apiClient';
import MockDataService from '../services/MockDataService';

const USE_MOCK = process.env.REACT_APP_USE_MOCK_DATA === 'true' || process.env.NODE_ENV === 'development';

// Helper to wrap response in { data: ... } format for backward compatibility with axios-style responses
const wrapResponse = (data) => ({ data });

export const getTenants = async (params = {}) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTenants(params);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet('/api/auth/organization/tenants', params);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet('/api/auth/organization/tenants', params);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTenants(params);
    return wrapResponse(response.data);
  }
};

export const createTenant = async (data) => {
  const response = await apiPost('/api/auth/organization/tenants', data);
  return wrapResponse(response);
};

export const getTenantById = async (tenantId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTenantById(tenantId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/api/auth/organization/tenants/${tenantId}`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/api/auth/organization/tenants/${tenantId}`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTenantById(tenantId);
    return wrapResponse(response.data);
  }
};

export const updateTenant = async (tenantId, data) => {
  const response = await apiPut(`/api/auth/organization/tenants/${tenantId}`, data);
  return wrapResponse(response);
};

export const deleteTenant = async (tenantId) => {
  const response = await apiDelete(`/api/auth/organization/tenants/${tenantId}`);
  return wrapResponse(response);
};

export const getTenantOrganizations = async (tenantId) => {
  const response = await apiGet(`/api/auth/organization/tenants/${tenantId}/organizations`);
  return wrapResponse(response);
};

export const getTenantStatistics = async (tenantId) => {
  if (USE_MOCK) {
    try {
      const response = await MockDataService.getTenantStatistics(tenantId);
      return wrapResponse(response.data);
    } catch (error) {
      const response = await apiGet(`/api/auth/organization/tenants/${tenantId}/statistics`);
      return wrapResponse(response);
    }
  }
  try {
    const response = await apiGet(`/api/auth/organization/tenants/${tenantId}/statistics`);
    return wrapResponse(response);
  } catch (error) {
    const response = await MockDataService.getTenantStatistics(tenantId);
    return wrapResponse(response.data);
  }
};

/**
 * Get organization by domain name
 * This is a public endpoint (no-auth) called on landing page
 * Backend endpoint: /api/no-auth/tenant/getorganizationbydomain?domainName={domain}
 * Gateway path: /api/no-auth/tenant/getorganizationbydomain?domainName={domain}
 * (Gateway should route /api/no-auth/* to registration service)
 * @param {string} domainName - Domain name to search for (e.g., "example.com")
 * @returns {Promise} Organization/tenant details
 */
export const getOrganizationByDomain = async (domainName) => {
  try {
    //console.log('🌐 Calling getOrganizationByDomain API with domain:', domainName);
    const response = await apiGet('/gateway/registration/api/no-auth/tenant/getorganizationbydomain', {
      domainName: domainName
    });
    //console.log('📥 getOrganizationByDomain API response:', response);
    return wrapResponse(response);
  } catch (error) {
    console.error('❌ Error fetching organization by domain:', error);
    console.error('❌ Error details:', {
      message: error.message,
      stack: error.stack
    });
    throw error;
  }
};

// Service object for backward compatibility
export const tenantService = {
  getTenants,
  createTenant,
  getTenantById,
  updateTenant,
  deleteTenant,
  getTenantOrganizations,
  getTenantStatistics,
  getOrganizationByDomain,
};

export default tenantService;
